/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Cue_Face_CameraInputs */

const en_us2_body_assessment_cue_face_camera = /** @type {(inputs: Body_Assessment_Cue_Face_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn to face the phone.`)
};

const pt_br2_body_assessment_cue_face_camera = /** @type {(inputs: Body_Assessment_Cue_Face_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vire de frente para o celular.`)
};

const es_419_body_assessment_cue_face_camera = /** @type {(inputs: Body_Assessment_Cue_Face_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponte de frente al teléfono.`)
};

const pt_pt2_body_assessment_cue_face_camera = /** @type {(inputs: Body_Assessment_Cue_Face_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vira-te de frente para o telemóvel.`)
};

const fr_fr2_body_assessment_cue_face_camera = /** @type {(inputs: Body_Assessment_Cue_Face_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tourne-toi face au téléphone.`)
};

const de_de2_body_assessment_cue_face_camera = /** @type {(inputs: Body_Assessment_Cue_Face_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dreh dich zum Handy.`)
};

const it_it2_body_assessment_cue_face_camera = /** @type {(inputs: Body_Assessment_Cue_Face_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Girati verso il telefono.`)
};

/**
* | output |
* | --- |
* | "Turn to face the phone." |
*
* @param {Body_Assessment_Cue_Face_CameraInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_cue_face_camera = /** @type {((inputs?: Body_Assessment_Cue_Face_CameraInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Cue_Face_CameraInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_cue_face_camera(inputs)
	if (locale === "es-419") return es_419_body_assessment_cue_face_camera(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_cue_face_camera(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_cue_face_camera(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_cue_face_camera(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_cue_face_camera(inputs)
	return en_us2_body_assessment_cue_face_camera(inputs)
});
export { body_assessment_cue_face_camera as "body-assessment.cue.face_camera" }